import { useState, useEffect } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import type { TemplateItem } from '@/pages/brutal/components/BrutalGrid';

const SUPABASE_CHECKOUT_URL = 'https://yhgqvcvxqajwiimtmmin.supabase.co/functions/v1/create-checkout';

const TEMPLATES: Record<string, TemplateItem> = {
  '2':  { id: 2,  name: 'ARK/8',             category: 'Agency',      tag: null, type: 'video', price: 20, priceId: 'template_premium',  poster: 'https://framerusercontent.com/images/e6ULDXMhILZCRqYzZOtoPJubCc.jpg', video: 'https://framerusercontent.com/assets/CqYxekPkybKUw3B9LdV4M4IdXU.mp4',  externalUrl: 'https://ark8.net/' },
  '3':  { id: 3,  name: 'Temporary State',   category: 'Typography',  tag: null, type: 'video', price: 20, priceId: 'template_standard', poster: 'https://framerusercontent.com/images/c0VWATPD5g0wT1E5YC1WqWVVILU.jpg', video: 'https://framerusercontent.com/assets/BGAzo1V2vn5iFN3Hq1y5irznAA.mp4', externalUrl: 'https://type.tmpstate.net/' },
  '4':  { id: 4,  name: 'The Blimp',         category: 'Personal',    tag: null, type: 'video', price: 20, priceId: 'template_basic',    poster: 'https://framerusercontent.com/images/T9M0du8UsfRz2SkbU6lRldJwNpo.jpg', video: 'https://framerusercontent.com/assets/3BCyyBBEO3jKbpjCjrGQsZgCTTY.mp4', externalUrl: 'https://www.blimp.gr/' },
  '5':  { id: 5,  name: 'Laxer',             category: 'Agency',      tag: null, type: 'video', price: 20, priceId: 'template_standard', poster: 'https://framerusercontent.com/images/83JEHDVVEQAkjP06IedBvGYBoMQ.jpg',  video: 'https://framerusercontent.com/assets/u3d0RGj20zs8rdTcxTOhBI3wu6g.mp4', externalUrl: 'https://davidlaxer.com/' },
  '6':  { id: 6,  name: 'Duncan Brazzil',    category: 'Personal',    tag: null, type: 'video', price: 20, priceId: 'template_basic',    poster: 'https://framerusercontent.com/images/ZASZrm2Fw9By3Qs9Fr0zjMp8.jpg',    video: 'https://framerusercontent.com/assets/CbGzVkrnxt0iGjhv3MfnTeZhClo.mp4', externalUrl: 'https://duncanbrazzil.com/' },
  '7':  { id: 7,  name: 'Cristina Gómez',    category: 'Photography', tag: null, type: 'video', price: 20, priceId: 'template_standard', poster: 'https://framerusercontent.com/images/zzgoMOtxNaR7UN3mk2rvvlaIfg.jpg',   video: 'https://framerusercontent.com/assets/dSX9NrSdHBrCYBNep5R1Cr7t2Q.mp4', externalUrl: 'https://cristinagomezruiz.com/' },
  '8':  { id: 8,  name: 'Pangram Pangram',   category: 'Typography',  tag: null, type: 'video', price: 20, priceId: 'template_premium',  poster: 'https://framerusercontent.com/images/cTICgYKnabvsGNq4NzM3wybiyM.jpg',  video: 'https://framerusercontent.com/assets/86vG8jhZVdaiQ4wCLPLDS7lKSfk.mp4', externalUrl: 'https://pangrampangram.com/' },
  '9':  { id: 9,  name: 'Basement Foundry',  category: 'Agency',      tag: null, type: 'video', price: 20, priceId: 'template_premium',  poster: 'https://framerusercontent.com/images/vwi0dMlnXI4rRixNYrBJDN8iw.jpg',   video: 'https://framerusercontent.com/assets/aWM7m7beeS1Z1xVB1sgEgjHCZGc.mp4', externalUrl: 'https://foundry.basement.studio/' },
  '10': { id: 10, name: 'Two Times Elliott', category: 'Agency',      tag: null, type: 'video', price: 20, priceId: 'template_standard', poster: 'https://framerusercontent.com/images/DAbTwqeO5EgJ0TBK8DXFBQt6N5E.jpg', video: 'https://framerusercontent.com/assets/LmaLe1EHIVpe70oWoqqQULaNXrQ.mp4', externalUrl: 'https://xx.studio/' },
  '11': { id: 11, name: 'Way TV',            category: 'Personal',    tag: null, type: 'video', price: 20, priceId: 'template_basic',    poster: 'https://framerusercontent.com/images/5ySCoIcmnYzqGmnyXwYQg2L8cNk.jpg',  video: 'https://framerusercontent.com/assets/qxws4EZ4hJhr28fsMMheGA3cms.mp4',  externalUrl: 'https://www.waytv.paris/' },
  '12': { id: 12, name: 'Cristian Oliva',    category: 'Photography', tag: null, type: 'video', price: 20, priceId: 'template_standard', poster: 'https://framerusercontent.com/images/O8dg50dwpeCMCRS3oYRocRqHVlw.jpg',  video: 'https://framerusercontent.com/assets/VOVLMQHMQGEkK7BGpGfB0GRTbU.mp4', externalUrl: 'https://cristianoliva-studio.com/' },
  '13': { id: 13, name: 'Bennett & Clive',   category: 'Agency',      tag: null, type: 'video', price: 20, priceId: 'template_premium',  poster: 'https://framerusercontent.com/images/p6mMDXyIn27rrbFoqzWPqY8ycY.jpg',  video: 'https://framerusercontent.com/assets/e3FJErSuGLir8whrL621Xo1A.mp4',   externalUrl: 'https://bennettandclive.com/' },
  '14': { id: 14, name: 'Seb Martinez',      category: 'Portfolio',   tag: null, type: 'video', price: 20, priceId: 'template_standard', poster: 'https://framerusercontent.com/images/0TPrKxo5EtAtKaLGa0fuxurrGc.jpg',  video: 'https://framerusercontent.com/assets/PRCD1ZRC30bgMNJB8MAxkb3PvRU.mp4', externalUrl: 'https://www.sebastian-martinez.com/' },
  '15': { id: 15, name: 'WOW Page',          category: 'Agency',      tag: null, type: 'video', price: 20, priceId: 'template_premium',  poster: 'https://framerusercontent.com/images/Ner5d3W6q58YuIth9mkA57fpJY.jpg',  video: 'https://framerusercontent.com/assets/SVVE9i7OvCFZeJdrA63ZLXnB2Sc.mp4', externalUrl: 'https://wowpage.io/' },
  '16': { id: 16, name: 'Monolith',          category: 'Agency',      tag: null, type: 'video', price: 20, priceId: 'template_standard', poster: 'https://framerusercontent.com/images/WOJESlfM8g3BKy6YGPNohTHIjq0.jpg', video: 'https://framerusercontent.com/assets/TWokztFxBqnGi61NMuBFkPbvQTY.mp4', externalUrl: 'https://monolith.nyc/' },
  '17': { id: 17, name: 'Synchrodogs',       category: 'Photography', tag: null, type: 'video', price: 20, priceId: 'template_basic',    poster: 'https://framerusercontent.com/images/PMrTRfuxurVEqOOXqOK9w6LQlMY.jpg', video: 'https://framerusercontent.com/assets/Jwv1TBVI0Q2GbX44K3ozRgZWyg.mp4',  externalUrl: 'https://synchrodogs.com/' },
  '18': { id: 18, name: 'MAPP MTL',          category: 'Agency',      tag: null, type: 'video', price: 20, priceId: 'template_standard', poster: 'https://framerusercontent.com/images/iC3r0RMrmayep4S9oR79GTcazM.jpg',  video: 'https://framerusercontent.com/assets/DtJDIFWaLlGhTmEhxq12M1zNkg.mp4', externalUrl: 'https://perspectives.mappmtl.com/en' },
  '19': { id: 19, name: 'Isabel Moranta',    category: 'Photography', tag: null, type: 'video', price: 20, priceId: 'template_basic',    poster: 'https://framerusercontent.com/images/oUQ1oNH5J3Psn4UIVYObS3i1M4.jpg',  video: 'https://framerusercontent.com/assets/69AbcKkk3GjiohDghLZS4J6vLc.mp4', externalUrl: 'https://www.isabelmoranta.com/' },
  '20': { id: 20, name: 'Baillat Studio',    category: 'Agency',      tag: null, type: 'video', price: 20, priceId: 'template_premium',  poster: 'https://framerusercontent.com/images/rgIxF3ESanq7Et1J3TFeZ2RlCY8.jpg', video: 'https://framerusercontent.com/assets/YqWeFmzmJGGWk8AHfSJWVWp3bk.mp4', externalUrl: 'https://baillatstudio.com/en' },
  '21': { id: 21, name: 'Duties',            category: 'E-Commerce',  tag: null, type: 'video', price: 20, priceId: 'template_standard', poster: 'https://framerusercontent.com/images/5GJYTYQZKnkyUjP4HnrTjSQwM8.jpg',  video: 'https://framerusercontent.com/assets/crMZvClCCb54u19UvguuATNz7Yo.mp4', externalUrl: 'https://www.duties.xyz/' },
  '22': { id: 22, name: 'Thibaud Fellay',    category: 'Photography', tag: null, type: 'video', price: 20, priceId: 'template_basic',    poster: 'https://framerusercontent.com/images/FWgUvc3HEuvVslrFiTyx03Myum8.jpg', video: 'https://framerusercontent.com/assets/TocpCFYjsr1jHyEXq17Y9AM2Z4.mp4', externalUrl: 'https://thibaud.film/' },
  '23': { id: 23, name: 'Mouthwash Studio',  category: 'Agency',      tag: null, type: 'video', price: 20, priceId: 'template_premium',  poster: 'https://framerusercontent.com/images/Ho7aF6AplOV0ECKQ28BH6Zs4ro.jpg', video: 'https://framerusercontent.com/assets/x4ZQsu5FpLH3X068KB5zmqrpMU.mp4', externalUrl: 'https://mouthwash.studio/' },
  '24': { id: 24, name: 'Designed By Paul',  category: 'Portfolio',   tag: null, type: 'video', price: 20, priceId: 'template_premium',  poster: 'https://framerusercontent.com/images/UemC1GXM0PMW70uu5EFwquVsE.jpg',   video: 'https://framerusercontent.com/assets/Qfus5tpOPTwHdCzAb0rlCkcbAw.mp4', externalUrl: 'https://designedbypaul.com/' },
  '25': { id: 25, name: 'Basement Studio',   category: 'Agency',      tag: null, type: 'video', price: 20, priceId: 'template_standard', poster: 'https://framerusercontent.com/images/VDHgOeTX1mEsJrKTbx0Npw6iCA.jpg',  video: 'https://framerusercontent.com/assets/D5jQ0X4kuKUlhVFAPpJixqHubbY.mp4', externalUrl: 'https://basement.studio/' },
  '26': { id: 26, name: 'Stenger Bikes',     category: 'E-Commerce',  tag: null, type: 'video', price: 20, priceId: 'template_standard', poster: 'https://framerusercontent.com/images/gUIyOc39A2RqYIDmowSsGlvYc4.jpg',  video: 'https://framerusercontent.com/assets/B6Vstm7729bd35NvlIdEfiIYVQM.mp4', externalUrl: 'https://stenger-bike.de/en/' },
  '27': { id: 27, name: 'Vikki Breusova',    category: 'Portfolio',   tag: null, type: 'video', price: 20, priceId: 'template_basic',    poster: 'https://framerusercontent.com/images/ybFrI0VVoqOuDkOx1GAnWgoOLk.jpg',  video: 'https://framerusercontent.com/assets/76X4LMtp7UZQ7eSzVnPlFHbJBs.mp4', externalUrl: 'https://www.vikkibre.com/' },
  '28': { id: 28, name: 'Locomotive',        category: 'Agency',      tag: null, type: 'video', price: 20, priceId: 'template_premium',  poster: 'https://framerusercontent.com/images/MMq1w7NGCjsWaOYc6qDsfvlepo.jpg',  video: 'https://framerusercontent.com/assets/O4vW6m6QRcUgjwXB20ZDZvn4.mp4',   externalUrl: 'https://locomotive.ca/en' },
};

type ModalMode = 'pay' | 'build' | null;

interface PayFormState {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
}

interface BuildFormState {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  businessName: string;
  budget: string;
  message: string;
}

function PayModal({ template, onClose }: { template: TemplateItem; onClose: () => void }) {
  const [form, setForm] = useState<PayFormState>({ firstName: '', lastName: '', email: '', phone: '' });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const res = await fetch(SUPABASE_CHECKOUT_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          packageId: template.priceId,
          templateName: template.name,
          customerEmail: form.email,
          customerName: `${form.firstName} ${form.lastName}`.trim(),
          successUrl: `${window.location.origin}/pay/success?template=${encodeURIComponent(template.name)}&email=${encodeURIComponent(form.email)}&name=${encodeURIComponent(form.firstName)}&tid=${template.id}`,
          cancelUrl: window.location.href,
        }),
      });
      const data = await res.json();
      if (data.url) {
        window.location.href = data.url;
      } else {
        setError(data.error || 'Could not start checkout. Please try again.');
      }
    } catch {
      setError('Network error. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 z-[200] flex items-end md:items-center justify-center" style={{ fontFamily: "'Inter', sans-serif" }}>
      <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" onClick={onClose} />
      <div className="relative bg-white w-full md:max-w-md md:rounded-2xl overflow-hidden" style={{ maxHeight: '92vh', overflowY: 'auto' }}>
        <div className="flex items-center justify-between px-6 py-4 border-b border-black/10 sticky top-0 bg-white z-10">
          <div className="flex items-center gap-3">
            <div className="w-8 h-8 rounded overflow-hidden flex-shrink-0 bg-black/5">
              <img src={template.poster} alt={template.name} className="w-full h-full object-cover object-top" />
            </div>
            <div>
              <p className="text-xs text-black/40 uppercase tracking-widest">Unlock Template</p>
              <h2 className="text-sm font-semibold text-black">{template.name}</h2>
            </div>
          </div>
          <button onClick={onClose} className="w-8 h-8 flex items-center justify-center text-black/40 hover:text-black transition-colors cursor-pointer rounded-full hover:bg-black/5">
            <i className="ri-close-line text-lg"></i>
          </button>
        </div>
        <form onSubmit={handleSubmit} className="px-6 py-6 flex flex-col gap-4">
          <div className="grid grid-cols-2 gap-3">
            <div className="flex flex-col gap-1.5">
              <label className="text-xs font-semibold text-black/50 uppercase tracking-wider">First Name *</label>
              <input type="text" required value={form.firstName} onChange={e => setForm(f => ({ ...f, firstName: e.target.value }))} placeholder="Jane" className="w-full border border-black/15 rounded-lg px-3 py-2.5 text-sm text-black placeholder-black/30 focus:outline-none focus:border-black transition-colors" />
            </div>
            <div className="flex flex-col gap-1.5">
              <label className="text-xs font-semibold text-black/50 uppercase tracking-wider">Last Name *</label>
              <input type="text" required value={form.lastName} onChange={e => setForm(f => ({ ...f, lastName: e.target.value }))} placeholder="Smith" className="w-full border border-black/15 rounded-lg px-3 py-2.5 text-sm text-black placeholder-black/30 focus:outline-none focus:border-black transition-colors" />
            </div>
          </div>
          <div className="flex flex-col gap-1.5">
            <label className="text-xs font-semibold text-black/50 uppercase tracking-wider">Email *</label>
            <input type="email" required value={form.email} onChange={e => setForm(f => ({ ...f, email: e.target.value }))} placeholder="jane@example.com" className="w-full border border-black/15 rounded-lg px-3 py-2.5 text-sm text-black placeholder-black/30 focus:outline-none focus:border-black transition-colors" />
          </div>
          <div className="flex flex-col gap-1.5">
            <label className="text-xs font-semibold text-black/50 uppercase tracking-wider">Phone *</label>
            <input type="tel" required value={form.phone} onChange={e => setForm(f => ({ ...f, phone: e.target.value }))} placeholder="+1 (555) 000-0000" className="w-full border border-black/15 rounded-lg px-3 py-2.5 text-sm text-black placeholder-black/30 focus:outline-none focus:border-black transition-colors" />
          </div>
          <div className="flex items-center justify-between bg-black/4 rounded-xl px-4 py-3">
            <div>
              <p className="text-xs text-black/50">Monthly subscription</p>
              <p className="text-sm font-semibold text-black">{template.name}</p>
              <p className="text-xs text-black/40">Cancel anytime</p>
            </div>
            <div className="text-right">
              <p className="text-2xl font-black text-black">$20</p>
              <p className="text-xs text-black/40">/month</p>
            </div>
          </div>
          {error && <p className="text-xs text-red-500 text-center">{error}</p>}
          <button type="submit" disabled={loading} className="w-full py-3 bg-black text-white text-sm font-semibold rounded-full hover:bg-black/80 transition-colors cursor-pointer whitespace-nowrap disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2">
            {loading ? <><i className="ri-loader-4-line animate-spin"></i> Redirecting...</> : <><i className="ri-secure-payment-line"></i> Subscribe $20/mo — Secure Checkout</>}
          </button>
          <p className="text-xs text-black/30 text-center">Powered by Stripe · SSL encrypted · Cancel anytime</p>
        </form>
      </div>
    </div>
  );
}

function BuildModal({ template, onClose }: { template: TemplateItem; onClose: () => void }) {
  const [form, setForm] = useState<BuildFormState>({ firstName: '', lastName: '', email: '', phone: '', businessName: '', budget: '', message: '' });
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const charCount = form.message.length;

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    const data = new URLSearchParams({
      template_name: template.name,
      template_category: template.category,
      template_url: template.externalUrl,
      request_type: 'Build My Website',
      first_name: form.firstName,
      last_name: form.lastName,
      email: form.email,
      phone: form.phone,
      business_name: form.businessName,
      budget: form.budget,
      message: form.message,
    });
    try {
      const res = await fetch('https://readdy.ai/api/form/d7e6ill37cef9t4028kg', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: data.toString(),
      });
      if (res.ok) setSubmitted(true);
      else setError('Something went wrong. Please try again.');
    } catch {
      setError('Network error. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 z-[200] flex items-end md:items-center justify-center" style={{ fontFamily: "'Inter', sans-serif" }}>
      <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" onClick={onClose} />
      <div className="relative bg-white w-full md:max-w-2xl md:rounded-2xl overflow-hidden" style={{ maxHeight: '92vh', overflowY: 'auto' }}>
        <div className="flex items-center justify-between px-6 py-4 border-b border-black/10 sticky top-0 bg-white z-10">
          <div className="flex items-center gap-3">
            <div className="w-8 h-8 rounded overflow-hidden flex-shrink-0 bg-black/5">
              <img src={template.poster} alt={template.name} className="w-full h-full object-cover object-top" />
            </div>
            <div>
              <p className="text-xs text-black/40 uppercase tracking-widest">Build My Website</p>
              <h2 className="text-sm font-semibold text-black">{template.name} style</h2>
            </div>
          </div>
          <button onClick={onClose} className="w-8 h-8 flex items-center justify-center text-black/40 hover:text-black transition-colors cursor-pointer rounded-full hover:bg-black/5">
            <i className="ri-close-line text-lg"></i>
          </button>
        </div>
        {submitted ? (
          <div className="flex flex-col items-center justify-center py-16 px-6 text-center">
            <div className="w-14 h-14 flex items-center justify-center rounded-full bg-black mb-4">
              <i className="ri-check-line text-white text-2xl"></i>
            </div>
            <h3 className="text-xl font-bold text-black mb-2">Request Sent!</h3>
            <p className="text-sm text-black/50 max-w-xs">We received your build request for <strong>{template.name}</strong>. We&apos;ll call you shortly.</p>
            <button onClick={onClose} className="mt-8 px-6 py-2.5 bg-black text-white text-sm font-semibold rounded-full hover:bg-black/80 transition-colors cursor-pointer whitespace-nowrap">Close</button>
          </div>
        ) : (
          <form data-readdy-form id="build-request-form" onSubmit={handleSubmit} className="px-6 py-6 flex flex-col gap-4">
            <p className="text-xs font-semibold text-black/40 uppercase tracking-widest">Build my website using this style</p>
            <div className="grid grid-cols-2 gap-3">
              <div className="flex flex-col gap-1.5">
                <label className="text-xs font-semibold text-black/50 uppercase tracking-wider">First Name *</label>
                <input type="text" required value={form.firstName} onChange={e => setForm(f => ({ ...f, firstName: e.target.value }))} placeholder="Jane" className="w-full border border-black/15 rounded-lg px-3 py-2.5 text-sm text-black placeholder-black/30 focus:outline-none focus:border-black transition-colors" />
              </div>
              <div className="flex flex-col gap-1.5">
                <label className="text-xs font-semibold text-black/50 uppercase tracking-wider">Last Name *</label>
                <input type="text" required value={form.lastName} onChange={e => setForm(f => ({ ...f, lastName: e.target.value }))} placeholder="Smith" className="w-full border border-black/15 rounded-lg px-3 py-2.5 text-sm text-black placeholder-black/30 focus:outline-none focus:border-black transition-colors" />
              </div>
            </div>
            <div className="flex flex-col gap-1.5">
              <label className="text-xs font-semibold text-black/50 uppercase tracking-wider">Email *</label>
              <input type="email" name="email" required value={form.email} onChange={e => setForm(f => ({ ...f, email: e.target.value }))} placeholder="jane@example.com" className="w-full border border-black/15 rounded-lg px-3 py-2.5 text-sm text-black placeholder-black/30 focus:outline-none focus:border-black transition-colors" />
            </div>
            <div className="flex flex-col gap-1.5">
              <label className="text-xs font-semibold text-black/50 uppercase tracking-wider">Phone *</label>
              <input type="tel" required value={form.phone} onChange={e => setForm(f => ({ ...f, phone: e.target.value }))} placeholder="+1 (555) 000-0000" className="w-full border border-black/15 rounded-lg px-3 py-2.5 text-sm text-black placeholder-black/30 focus:outline-none focus:border-black transition-colors" />
            </div>
            <div className="flex flex-col gap-1.5">
              <label className="text-xs font-semibold text-black/50 uppercase tracking-wider">Business / Project Name</label>
              <input type="text" value={form.businessName} onChange={e => setForm(f => ({ ...f, businessName: e.target.value }))} placeholder="My Brand Co." className="w-full border border-black/15 rounded-lg px-3 py-2.5 text-sm text-black placeholder-black/30 focus:outline-none focus:border-black transition-colors" />
            </div>
            <div className="flex flex-col gap-1.5">
              <label className="text-xs font-semibold text-black/50 uppercase tracking-wider">Budget Range</label>
              <select value={form.budget} onChange={e => setForm(f => ({ ...f, budget: e.target.value }))} className="w-full border border-black/15 rounded-lg px-3 py-2.5 text-sm text-black focus:outline-none focus:border-black transition-colors bg-white cursor-pointer">
                <option value="">Select a range...</option>
                <option value="Under $1,000">Under $1,000</option>
                <option value="$1,000 – $3,000">$1,000 – $3,000</option>
                <option value="$3,000 – $7,500">$3,000 – $7,500</option>
                <option value="$7,500 – $15,000">$7,500 – $15,000</option>
                <option value="$15,000+">$15,000+</option>
              </select>
            </div>
            <div className="flex flex-col gap-1.5">
              <label className="text-xs font-semibold text-black/50 uppercase tracking-wider">Tell us about your project</label>
              <textarea value={form.message} onChange={e => setForm(f => ({ ...f, message: e.target.value }))} placeholder="Describe your business, goals, and what you need..." maxLength={500} rows={4} className="w-full border border-black/15 rounded-lg px-3 py-2.5 text-sm text-black placeholder-black/30 focus:outline-none focus:border-black transition-colors resize-none" />
              <p className="text-xs text-black/30 text-right">{charCount}/500</p>
            </div>
            {error && <p className="text-xs text-red-500 text-center">{error}</p>}
            <button type="submit" disabled={loading} className="w-full py-3 bg-black text-white text-sm font-semibold rounded-full hover:bg-black/80 transition-colors cursor-pointer whitespace-nowrap disabled:opacity-50 disabled:cursor-not-allowed">
              {loading ? 'Sending...' : 'Send Build Request'}
            </button>
            <p className="text-xs text-black/30 text-center">We typically call within 24 hours.</p>
          </form>
        )}
      </div>
    </div>
  );
}

export default function TemplatePreviewPage() {
  const { templateId } = useParams<{ templateId: string }>();
  const navigate = useNavigate();
  const [modalMode, setModalMode] = useState<ModalMode>(null);
  const [iframeLoaded, setIframeLoaded] = useState(false);

  const template = templateId ? TEMPLATES[templateId] : null;

  useEffect(() => { window.scrollTo(0, 0); }, []);

  if (!template) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white" style={{ fontFamily: "'Inter', sans-serif" }}>
        <div className="text-center">
          <p className="text-black/40 text-sm mb-4">Template not found.</p>
          <Link to="/" className="text-sm text-black underline">Back to gallery</Link>
        </div>
      </div>
    );
  }

  return (
    <div className="h-screen flex flex-col overflow-hidden" style={{ fontFamily: "'Inter', sans-serif" }}>

      {/* Top bar */}
      <header className="flex-shrink-0 z-50 bg-white border-b border-black/10 px-5 h-12 flex items-center justify-between">
        <div className="flex items-center gap-4">
          <button onClick={() => navigate('/')} className="text-sm text-black hover:opacity-50 transition-opacity flex items-center gap-1.5 cursor-pointer whitespace-nowrap">
            <i className="ri-arrow-left-line text-sm"></i>
            Templates
          </button>
          <span className="text-black/20 hidden sm:block">|</span>
          <span className="text-sm text-black font-semibold hidden sm:block">{template.name}</span>
          <span className="text-xs text-black/40 bg-black/5 px-2 py-0.5 rounded-full hidden sm:block">{template.category}</span>
        </div>
        <button
          onClick={() => setModalMode('pay')}
          className="px-4 py-1.5 bg-black text-white text-xs font-bold rounded-full hover:bg-black/80 transition-colors cursor-pointer whitespace-nowrap"
        >
          Unlock — $20/mo
        </button>
      </header>

      {/* iframe area — scrollable, takes remaining height */}
      <div className="relative flex-1 overflow-hidden">

        {/* Loading spinner */}
        {!iframeLoaded && (
          <div className="absolute inset-0 flex items-center justify-center z-10 bg-[#f0f0f0]">
            <div className="flex flex-col items-center gap-3">
              <i className="ri-loader-4-line text-2xl text-black/30 animate-spin"></i>
              <p className="text-xs text-black/40">Loading preview...</p>
            </div>
          </div>
        )}

        {/* Scrollable iframe — full height, user can scroll */}
        <iframe
          src={template.externalUrl}
          title={template.name}
          className="w-full border-0"
          style={{ height: '100%', display: 'block' }}
          onLoad={() => setIframeLoaded(true)}
          sandbox="allow-scripts allow-same-origin allow-forms"
        />

        {/* Bottom fade gradient — purely visual, non-blocking */}
        <div
          className="absolute bottom-[72px] left-0 right-0 h-32 pointer-events-none"
          style={{ background: 'linear-gradient(to bottom, transparent, rgba(255,255,255,0.6))' }}
        />
      </div>

      {/* Sticky bottom action bar */}
      <div className="flex-shrink-0 bg-white border-t border-black/10 px-5 py-3 flex flex-col sm:flex-row items-center justify-between gap-3 z-50">
        <div className="hidden sm:flex items-center gap-2">
          <div className="w-6 h-6 flex items-center justify-center rounded-full bg-black/8">
            <i className="ri-lock-line text-black text-xs"></i>
          </div>
          <p className="text-xs text-black/50">
            You&apos;re viewing a preview of <strong className="text-black">{template.name}</strong> — unlock the full template for $20/mo
          </p>
        </div>
        <div className="flex items-center gap-2 flex-shrink-0">
          {/* Back to templates */}
          <button
            onClick={() => navigate('/')}
            className="flex items-center gap-1.5 px-4 py-2 border border-black/20 text-black/60 text-xs font-semibold rounded-full hover:border-black hover:text-black transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-home-line text-xs"></i>
            <span className="hidden sm:inline">Back to Templates</span>
            <span className="sm:hidden">Home</span>
          </button>

          {/* Build for me */}
          <button
            onClick={() => setModalMode('build')}
            className="flex items-center gap-1.5 px-4 py-2 border-2 border-black text-black text-xs font-bold rounded-full hover:bg-black hover:text-white transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-hammer-line text-xs"></i>
            Build for Me
          </button>

          {/* Pay / unlock */}
          <button
            onClick={() => setModalMode('pay')}
            className="flex items-center gap-1.5 px-5 py-2 bg-black text-white text-xs font-bold rounded-full hover:bg-black/80 transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-secure-payment-line text-xs"></i>
            Unlock — $20/mo
          </button>
        </div>
      </div>

      {/* Modals */}
      {modalMode === 'pay' && <PayModal template={template} onClose={() => setModalMode(null)} />}
      {modalMode === 'build' && <BuildModal template={template} onClose={() => setModalMode(null)} />}
    </div>
  );
}
